import { Link } from 'react-router';
import type { Board } from '@hhm/shared';
import { useTextDoc } from '../../api/queries.js';
import { SkeletonRows } from '../../components/Loading.js';
import { registerBoardTypeUi } from '../registry.js';
import { previewText } from './serialize.js';
import { TextBoardPage } from './TextBoardPage.js';

function Card({ board }: { board: Board }) {
  const { data, isLoading } = useTextDoc(board.householdId, board.id);
  const preview = data !== undefined ? previewText(data.doc.blocks) : '';

  return (
    <Link to={`/households/${board.householdId}/boards/${board.id}`} className="card">
      <strong>{board.title}</strong>
      {isLoading ? <SkeletonRows count={2} /> : <p className="textdoc-preview">{preview === '' ? 'Empty' : preview}</p>}
    </Link>
  );
}

registerBoardTypeUi('text', { Card, Page: TextBoardPage });
